import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from "react-redux";
import App from './js/app';
import { injectStore } from "./js/server/api";
import configureStore from "./js/stores/configure-store.js";
import * as serviceWorker from './js/service-workers/service-worker';
import './css/index.css';

const store = configureStore();
injectStore(store);

ReactDOM.render(
    <Provider store={store}>
        <App />
    </Provider>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();